import { formatSecondsToTimestamp } from "@memorang/helpers/common";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Button from "../Button";

type Props = {
	initialResendEmailIn: number;
	disabled?: boolean;
	onResend: () => void;
};

export const AuthResendButton = ({
	initialResendEmailIn,
	disabled = false,
	onResend,
}: Props) => {
	const [resendEmailIn, setResendEmailIn] = useState(initialResendEmailIn);
	const disabledResend = disabled || resendEmailIn > 0;

	const theme = useAppTheme();
	const { t } = useTranslation();

	useEffect(() => {
		if (initialResendEmailIn) {
			setResendEmailIn(initialResendEmailIn);
		}
	}, [initialResendEmailIn]);

	useEffect(() => {
		let timeout: ReturnType<typeof setTimeout>;
		if (resendEmailIn > 0) {
			timeout = setTimeout(() => {
				setResendEmailIn((prev) => prev - 1);
			}, 1000);
		}
		return () => {
			if (timeout) {
				clearTimeout(timeout);
			}
		};
	}, [resendEmailIn]);

	return (
		<Button
			testID="auth-resend-button"
			mode="text"
			onPress={onResend}
			style={{ width: "100%" }}
			disabled={disabledResend}
			pointerEvents={disabledResend ? "none" : "auto"}
		>
			<Text
				variant="bodyMedium"
				style={{
					color: disabledResend
						? theme.palette.text.disabled
						: theme.colors.primary,
				}}
			>
				{resendEmailIn > 0
					? t("auth.verify.resendMagicLinkIn", {
							time: formatSecondsToTimestamp(resendEmailIn, {
								padMinutes: true,
							}),
						})
					: t("auth.verify.resendMagicLink")}
			</Text>
		</Button>
	);
};
